export const MixpanelEventTypes = {
    translation: {
        clickedOnTranslationButton: 'Machine translation - translated',
        clickedOnCancelledTranslationButton: 'Machine translation - show original',
    },
};
